var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { staticClass: "px-0", attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.left",
                      value: _vm.$t(
                        "apeironGwApp.alumnoSnp.ligado.verProfesores"
                      ),
                      expression:
                        "$t('apeironGwApp.alumnoSnp.ligado.verProfesores')",
                      modifiers: { hover: true, left: true },
                    },
                  ],
                  attrs: { variant: "outline" },
                  on: { click: _vm.mostrarModal },
                },
                [
                  _c("b-icon", {
                    attrs: { icon: "file-earmark-person", variant: "primary" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-modal",
                {
                  attrs: {
                    id: "modal-alumno-relacionado-snp",
                    scrollable: "",
                    size: "xl",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.alumnoSnp.ligado.tituloLigado"
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-3",
                              attrs: { variant: "secondary" },
                              on: {
                                click: function ($event) {
                                  _vm.mostrarModalProfesores = false
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.alumnoSnp.acciones.cerrar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.mostrarModalProfesores,
                    callback: function ($$v) {
                      _vm.mostrarModalProfesores = $$v
                    },
                    expression: "mostrarModalProfesores",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "d-block text-center" }, [
                        _c("h4", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "apeironGwApp.alumnoSnp.ligado.datosAlumno"
                              )
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.alumnoSnp.form.cvuAlumno"
                                ),
                                "label-for": "input-cvu",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-cvu",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.alumnoSnp.form.cvuAlumno"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.alumno.participante.cvu,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumno.participante,
                                      "cvu",
                                      $$v
                                    )
                                  },
                                  expression: "alumno.participante.cvu",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.alumnoSnp.form.nombreAlumno"
                                ),
                                "label-for": "input-nombre-alumno",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-nombre-alumno",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.alumnoSnp.form.nombreAlumno"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.alumno.participante.nombre,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumno.participante,
                                      "nombre",
                                      $$v
                                    )
                                  },
                                  expression: "alumno.participante.nombre",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.alumnoSnp.form.apellidoPaterno"
                                ),
                                "label-for": "input-apellido-paterno",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-apellido-paterno",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.alumnoSnp.form.apellidoPaterno"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.alumno.participante.apellidoPaterno,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumno.participante,
                                      "apellidoPaterno",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumno.participante.apellidoPaterno",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.alumnoSnp.form.apellidoMaterno"
                                ),
                                "label-for": "input-apellido-materno",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-apellido-materno",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.alumnoSnp.form.apellidoMaterno"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.alumno.participante.apellidoMaterno,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumno.participante,
                                      "apellidoMaterno",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumno.participante.apellidoMaterno",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "d-block text-center mt-5" }, [
                        _c("h4", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("apeironGwApp.alumnoSnp.ligado.profesores")
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c("b-table", {
                            attrs: {
                              "sticky-header": "500px",
                              fields: _vm.fieldsProfesores,
                              items: _vm.profesoresLigados,
                              "head-variant": "dark",
                              busy: _vm.showLoading,
                              "show-empty": "",
                              "empty-text": _vm.$t(
                                "apeironGwApp.alumnoSnp.ligado.sinRegistros"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "table-busy",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "text-center my-2" },
                                      [
                                        _c("b-spinner", {
                                          staticClass: "align-middle",
                                        }),
                                        _vm._v(" "),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "global.process.load.loading"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "cell(profesor)",
                                fn: function (data) {
                                  return [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          data.item?.profesor?.participante
                                            ?.nombre
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span"),
                                    _vm._v(" "),
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          data.item?.profesor?.participante
                                            ?.apellidoPaterno
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span"),
                                    _vm._v(" "),
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          data.item?.profesor?.participante
                                            ?.apellidoMaterno
                                        ),
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "cell(asociado)",
                                fn: function (data) {
                                  return [
                                    data.item.alumno.asociado
                                      ? _c("b-icon", {
                                          attrs: {
                                            icon: "check2-square",
                                            variant: "success",
                                            "font-scale": "2",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !data.item.alumno.asociado
                                      ? _c("b-icon", {
                                          attrs: {
                                            icon: "square",
                                            variant: "secondary",
                                            "font-scale": "2",
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "cell(alumno)",
                                fn: function (data) {
                                  return [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          data.item?.alumno?.relacion?.nombre
                                        ),
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }